import { useController, useFormContext } from 'react-hook-form';
import InputComponent from './component';

// must be in scope of react hook from context
const Input = ({
  name, required = false, control, ...restProps
}) => {
  const {
    field: { ref, onChange, ...inputProps },
    fieldState: { error, isTouched },
  } = useController({
    name,
    control,
    rules: { required },
    defaultValue: [],
    shouldUnregister: false,
  });

  return (
    <InputComponent
      {...inputProps}
      {...restProps}
      error={error}
      required={required}
      name={name}
      onChange={onChange}
      isTouched={isTouched}
    />
  );
};

export default Input;
